<template>
  <div>
    <el-form :model="ruleForm" ref="ruleForm" label-position="top" class="post-form">
      <section class="post-section">
        <h3 class="post-section__title">Documento fiscal</h3>
        <el-form-item v-if="service && service.dce" prop="typeContent">
          <el-radio v-model="ruleForm.typeContent" label="1" value="1">Com nota fiscal</el-radio>
          <el-radio v-model="ruleForm.typeContent" label="2" value="2">Com DC-E</el-radio>
          <el-radio v-model="ruleForm.typeContent" label="3" value="3">Emitir DC-E</el-radio>
          <el-radio v-model="ruleForm.typeContent" label="4" value="4">Enviar NF-E posteriormente</el-radio>
          <el-radio v-model="ruleForm.typeContent" label="5" value="5">Isento de DC-E</el-radio>
        </el-form-item>
        <template v-if="ruleForm.typeContent == '1'">
          <el-form-item label="Chave NFE" prop="nfeValue">
            <el-input v-model="ruleForm.nfeKey" placeholder="Digite a chave NFE" maxlength="44"></el-input>
          </el-form-item>
          <el-row :gutter="5">
            <el-col :xs="24" :sm="8">
              <el-form-item label="Número da Nota" prop="nfeNumber">
                <el-input v-model="ruleForm.nfeNumber" placeholder="Digite o número da nota"></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="8">
              <el-form-item label="Número de Série" prop="nfeSerie">
                <el-input v-model="ruleForm.nfeSerie" placeholder="Digite o número de série"></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="8">
              <el-form-item label="Valor da Nota" prop="nfeValue">
                <el-input
                  type="number"
                  v-model="ruleForm.nfeValue"
                  placeholder="Digite o valor da nota"
                  min="0"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </template>
        <el-row :gutter="5" v-if="ruleForm.typeContent === '2'">
          <el-col :xs="24" :sm="12" :md="10">
            <el-form-item label="Código DC-E" prop="dceId">
              <el-input v-model="ruleForm.dceId" placeholder="Digite o código da DC-E"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-alert
          v-if="ruleForm.typeContent === '3'"
          class="fs-14"
          type="info"
          title="Ao emitir a DC-E você deverá informar a Declaração de Conteúdo no botão abaixo. A DC-E é um documento que substitui a nota fiscal e deve conter as informações da descrição do conteúdo, valor declarado e outras informações relevantes para a postagem."
          :closable="false"
        ></el-alert>
        <el-alert
          v-if="ruleForm.typeContent === '4'"
          class="fs-14"
          type="error"
          title="Nesse caso a pre-posatagem ficará pendente e você poderá enviar a chave NF-E ou DC-E posteriormente."
          :closable="false"
        ></el-alert>
        <el-alert
          v-if="ruleForm.typeContent === '5'"
          class="fs-14"
          type="info"
          title="A pré-postagem será enviada com o serviço adicional Isento de Documento Fiscal, sem nota fiscal e sem emissão de DC-E."
          :closable="false"
        ></el-alert>
      </section>

      <section class="post-section">
        <h3 class="post-section__title">Declaração de conteudo</h3>
        <el-row :gutter="5">
          <el-col :xs="24" :sm="10">
            <el-form-item :label="$t('descricao')">
              <el-input v-model="ruleForm.content" maxlength="100"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="4">
            <el-form-item :label="$t('quantidade')">
              <el-input type="number" v-model="ruleForm.quantity" maxlength="5"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="5">
            <el-form-item :label="$t('valor')">
              <el-input type="text" v-model="ruleForm.value" v-money.lazy="money" ref="money"> </el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="5">
            <el-form-item label="&nbsp;">
              <el-button type="primary" class="post-button-block" @click="add()">Adicionar</el-button>
            </el-form-item>
          </el-col>
        </el-row>
        <el-table
          v-if="tableData.length"
          :data="tableData"
          ref="tableData"
          class="post-table"
          style="width: 100%"
          :default-sort="{ prop: 'content', order: 'ascending' }"
        >
          <el-table-column prop="content" :label="$t('descricao')"></el-table-column>
          <el-table-column prop="quantity" :label="$t('quantidade')" width="110"></el-table-column>
          <el-table-column prop="value" :label="$t('valor')" width="120">
            <template slot-scope="scope">{{ scope.row.valueData }}</template>
          </el-table-column>
          <el-table-column label="#" width="70" align="right">
            <template slot-scope="scope">
              <el-button
                type="text"
                class="post-table__remove"
                icon="el-icon-delete"
                @click="remove(scope.$index, scope.row.item)"
              ></el-button>
            </template>
          </el-table-column>
        </el-table>
      </section>
    </el-form>
  </div>
</template>
<script>
import MoneyMixins from "../../../../xpost/mixins/money";
export default {
  name: "PostDeclaredContent",
  mixins: [MoneyMixins],
  computed: {
    valueData() {
      return +this.ruleForm.value.replace("R$", "").replace(/\./g, "").replace(",", ".");
    },
  },
  methods: {
    setup(form, data, service) {
      this.service = service;
    },
    remove(index, row) {
      this.tableData.splice(index, 1);
    },
    add() {
      if (!this.ruleForm.content) {
        return this.$message({
          type: "error",
          message: "Informe uma descrição!",
        });
      }
      if (this.valueData <= 0) {
        return this.$message({
          type: "error",
          message: "Valor deve ser maior que zero!",
        });
      }
      console.log(this.valueData);
      this.tableData.push({
        content: this.ruleForm.content,
        quantity: this.ruleForm.quantity,
        value: this.valueData,
        valueData: this.ruleForm.value,
      });
    },
  },
  data() {
    return {
      service: null,
      tableData: [],
      ruleForm: {
        content: "",
        quantity: 1,
        value: "R$ 0,00",
        typeContent: "1",
        nfeKey: "",
        nfeNumber: "",
        nfeSerie: "",
        nfeValue: "",
        dceId: "",
      },
      dataNf: {
        nfeValue: "",
        nfeNumber: "",
        nfeSerie: "",
        hasNf: false,
      },
    };
  },
};
</script>
